import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { BackgroundModel } from 'src/app/engine/models/background.model';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';

@Component({
  selector: 'app-swatch-item',
  templateUrl: './swatch-item.component.html',
  styleUrls: ['./swatch-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SwatchItemComponent implements OnInit {

  @Input()
  color: BackgroundModel;

  @Input()
  size: 'x-small' | 'small' | 'medium' | 'large' | 'x-large' = 'medium';

  @Input()
  selected: false;

  get isTransparent(): boolean {
    return this.color && BackgroundModel.isTransparent(this.color);
  }

  constructor(
    private domSanitizer: DomSanitizer
  ) { }

  ngOnInit() {
  }

  getBackgroundCSS(): SafeStyle {
    if (this.color && !this.isTransparent) {
      const css = BackgroundModel.toCSS(this.color);
      return this.domSanitizer.bypassSecurityTrustStyle(css);
    } else {
      return null;
    }
  }

}
